import styled from "styled-components";

export const AdminStyled = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100dvh;

  .blocoAdm {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    border: 2px solid var(--cor-primaria);
    box-shadow: 2px 2px 10px var(--shadow);
    padding: 40px 60px;
    border-radius: 10px;
    gap: 30px;
    max-width: 80%;
    max-height: 80%;

    .blocoListas {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: var(--cor-primaria);
      color: var(--branco);
      font-size: 20px;
      width: 200px;
      max-width: 100%;
      height: 250px;
      max-height: 100%;
      border-radius: 10px;
      cursor: pointer;
      border: 0px solid transparent;
      transition: 0.2s;
      gap: 20px;

      img {
        width: 60%;
      }
    }
    .blocoListas:hover {
      transition: 0.2s;
      background: var(--cor-secundaria);
      box-shadow: 2px 2px 10px var(--shadow);
    }
  }

  /* Estilos para dispositivos móveis em modo retrato */
  @media only screen and (max-width: 800px) and (orientation: portrait) {
    .blocoAdm {
      /* height: 70vh; */
      overflow: auto;
      gap: 10px;
    }
  }

  /* Estilos para dispositivos móveis em modo paisagem */
  /* @media only screen and (max-width: 940px) and (orientation: landscape) {
    padding-top: 6em;
    margin-top: 3.6em;
    .blocoAdm {
      height: 100vh;
      gap: 10px;
      width: 85%;
      .blocoListas {
        width: 180px;
        height: 250px;
      }
    }
  } */
`;

export const TabelaStyled = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100dvh;

  .bloco {
    display: flex;
    flex-direction: column;
    gap: 30px;
    border: 4px solid var(--cor-primaria);
    border-radius: 10px;
    box-shadow: 2px 2px 10px var(--shadow);
    padding: 20px;
    z-index: 3;
    h3 {
      font-size: 1.6em;
      color: var(--cor-contraste);
      width: 100%;
      text-align: center;
    }
  }

  .blocoTabela {
    height: 250px;
    border: 2px solid var(--cor-primaria);
    box-shadow: 2px 2px 10px var(--shadow);
    border-radius: 10px;
    overflow-y: auto;
    padding: 0.6rem;

    table {
      width: fit-content;
      border-collapse: collapse; //usar na tabela Poço
      font-size: 1em;

      tbody {
        position: relative;
        .off {
          width: 6px;
          height: 27px;
          position: absolute;
          background-color: rgba(170, 170, 170, 1);
          left: -5px;
          border-radius: 5px 0px 0px 5px;
          border: 2px solid rgba(73, 73, 73, 0.59);
        }
        .on {
          background-color: rgb(1, 212, 15);
        }

        .gtw {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          overflow: hidden;
          transition: 0.8s;
          color: transparent;
        }
        .gtw:hover {
          width: 80%;
          color: rgb(38, 38, 38);
        }
        tr {
          cursor: pointer;
        }
        .select {
          background-color: var(--cor-cinza);
        }
        tr:hover {
          background-color: var(--cor-cinza);
        }
        .seleciona {
          background-color: var(--cor-cinza);
        }
      }
      td {
        padding: 0.3em;
        border: 1px solid var(--cor-contraste);
      }
      thead {
        background: var(--cor-cinza);
      }
      th {
        padding: 0.3em 0.3em;
      }
    }
  }

  .Botao {
    display: flex;
    gap: 20px;
    width: 100%;
    justify-content: space-between;
    button {
      font-size: 1em;
      background: var(--branco);
      border-radius: 3px;
      width: 30%;
      padding: 0.6em 0;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
      transition: 0.3s;
    }
    button:hover {
      background: var(--degrade);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 10px var(--shadow);
    }
  }

  /* Estilos para dispositivos móveis em modo retrato */
  @media only screen and (max-width: 800px) and (orientation: portrait) {
    .bloco {
      margin: auto 10px;
      padding: 10px;
      .blocoTabela {
        table {
          font-size: 0.8em;
          td,
          th {
            max-width: 50px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .Botao {
      gap: 10px;
      button {
        font-size: 0.8em;
      }
    }
  }

  /* Estilos para dispositivos móveis em modo paisagem */
  @media only screen and (max-width: 940px) and (orientation: landscape) {
    margin-top: 150px;
    .bloco {
      margin: auto 0;
      .blocoTabela {
        table {
          font-size: 1em;
          td,
          th {
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
`;
